export const getInitialState = () => ({
  navLocked: false,
  message: '',
});
